import { render, staticRenderFns } from "./IconText.vue?vue&type=template&id=22528021"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports